import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { AccountDeletionImpactResponseDto } from '@/types/dtos/users/response/account-deletion-impact.dto.ts';

export const GET_ACCOUNT_DELETION_IMPACT_QUERY_KEY = 'get-account-deletion-impact';

export const useAccountDeletionImpactQuery = () => {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: [GET_ACCOUNT_DELETION_IMPACT_QUERY_KEY],
    queryFn: async () => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/users/me/account-deletion-impact`;
      return sendJSONRequest({
        url,
        method: METHOD.GET,
        token: token ?? '',
      }) as Promise<AccountDeletionImpactResponseDto>;
    },
  });
};
